import "./WizardHeader.scss";

interface StepInactiveProps {
  hideMobilClass: string;
  stepNumber: number;
  text: string;
}

const StepInactive = ({
  hideMobilClass,
  stepNumber,
  text,
}: StepInactiveProps) => {
  return (
    <div className={`stepItem${hideMobilClass ? ` ${hideMobilClass}` : ""}`}>
      <div className="stepItemBox stepItemBoxInActive">
        {stepNumber.toString()}
      </div>
      <div className="stepItemText">{text}</div>
    </div>
  );
};

export default StepInactive;
